var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-bag-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.6657 5.33333C10.6657 6.04058 10.3848 6.71885 9.88469 7.21895C9.3846 7.71905 8.70632 8 7.99907 8C7.29183 8 6.61355 7.71905 6.11346 7.21895C5.61336 6.71885 5.33241 6.04058 5.33241 5.33333M2.42122 4.93426L1.95455 10.5343C1.8543 11.7373 1.80418 12.3388 2.00753 12.8028C2.1862 13.2105 2.49576 13.5469 2.8872 13.7588C3.33272 14 3.93631 14 5.1435 14H10.8546C12.0618 14 12.6654 14 13.1109 13.7588C13.5024 13.5469 13.812 13.2105 13.9906 12.8028C14.194 12.3388 14.1438 11.7373 14.0436 10.5343L13.5769 4.93426C13.4907 3.89917 13.4475 3.38162 13.2183 2.9899C13.0165 2.64496 12.7159 2.3684 12.3554 2.1959C11.946 2 11.4267 2 10.388 2L5.61017 2C4.57149 2 4.05215 2 3.64275 2.1959C3.28224 2.3684 2.98167 2.64496 2.77982 2.9899C2.55061 3.38162 2.50748 3.89917 2.42122 4.93426Z",
    stroke: "#01588C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.13ffe630c10bb5087702b3e5ea4ca1d4.svg";
export { ForwardRef as ReactComponent };